/** React/i18next bootstrap — import from `@dwim/i18n/client`, not the main entry (server-safe). */
export { createI18n } from "./create-i18n";
